import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from 'react';

const BlackTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
  arrow: {
    '&::before': {
      backgroundColor: theme.palette.common.black,
    },
  },
}))(Tooltip);

const OverflowTooltip = props => {
  const textElementRef = useRef(null);
  const { placement: tooltipPlacement, tooltip: title, text } = props;

  const [hoverStatus, setHover] = useState(false);

  const compareSize = () => {
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, []);

  return (
    <BlackTooltip
      title={title}
      interactive
      disableHoverListener={!hoverStatus}
      placement={tooltipPlacement}
      arrow
    >
      <div
        ref={textElementRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {text}
      </div>
    </BlackTooltip>
  );
};

export default OverflowTooltip;
